import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';
import { MCPAppsProvider } from 'site-modules/canvas/components/mcp-apps-provider/mcp-apps-provider';

const getSearch658Recipe = state =>
  ExperimentUtil.getForcedOrAssignedRecipeName({
    state,
    campaignName: 'search-658-mcp-rc',
    defaultVal: 'ctrl',
  });

export const withMcpApps = config => Component => {
  const WithMcpApps = forwardRef((props, ref) => {
    const search658Recipe = useSelector(getSearch658Recipe);
    const { mcpBaseUrl, sandboxHtmlUrl } = typeof config === 'function' ? config({ search658Recipe }) : config;

    return (
      <MCPAppsProvider mcpBaseUrl={mcpBaseUrl} sandboxHtmlUrl={sandboxHtmlUrl}>
        <Component {...props} ref={ref} />
      </MCPAppsProvider>
    );
  });

  WithMcpApps.displayName = `withMcpApps(${Component.displayName || Component.name})`;

  return WithMcpApps;
};
